import { Tuple } from '../base/Tuple.js';
/**
 * @name Range
 * @description
 * Rust `Range<T>` representation
 */
export class Range extends Tuple {
  constructor(registry, Type, value) {
    let {
      rangeName = 'Range'
    } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super(registry, [Type, Type], value);
    this.__internal__rangeName = rangeName;
  }
  static with(Type) {
    return class extends Range {
      constructor(registry, value) {
        super(registry, Type, value);
      }
    };
  }
  /**
   * @description Returns the starting range value
   */
  get start() {
    return this[0];
  }
  /**
   * @description Returns the ending range value
   */
  get end() {
    return this[1];
  }
  /**
   * @description Returns the base runtime type name for this instance
   */
  toRawType() {
    return "".concat(this.__internal__rangeName, "<").concat(this.start.toRawType(), ">");
  }
}